import React from 'react'
import Image from './Image'
import { injectIntl } from "gatsby-plugin-intl"

class Card extends React.Component {

    render() {
        const { intl } = this.props
        const title = `${this.props.type}.${this.props.title}.title`
        const description = `${this.props.type}.${this.props.title}.description`

        return (
                <div className="col-item">
                    <div className="box-item box-left">
                        <h3 className="box-item-title">
                            { intl.formatMessage({id: title}) }
                        </h3>
                        <div className="layout-flex" >
                            <Image filename={`${this.props.title}.png`} alt={`${this.props.title}`}  className="mini-image" />
                        <p className="flex-1 box-item-subtext" >
                        { intl.formatMessage({id: description}) }
                        </p>
                        </div>
                    </div>
                </div>
        )
    }
}

export default injectIntl(Card)
